import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { axiosapi } from '../../api/axiosapi'

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const OperatorTicketComponent = () => {
    const axiosPrivate = useAxiosPrivate();
    const { ticketId } = useParams();
    const [booking, setbooking] = useState();
    const [date, setdate] = useState();
    useEffect(() => {

        const fetchBookingDetails = async () => {
            const options = {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
            const response = await axiosPrivate.post("/booking/findbybookingid", { bookingid: ticketId })
            setbooking(response.data.booking)
            console.log(response.data.booking)
            const utcDateString = response.data.booking?.bookedFor;
            const utcDate = new Date(utcDateString);
            const istDate = new Date(utcDate.getTime() + 330 * 60 * 1000);
            const formattedDate = istDate.toLocaleDateString('en-In', options)
            setdate(formattedDate);




        }
        fetchBookingDetails();
    }, [])



    return (
        <div>
            <p className='text-center text-xl font-bold mt-4 mb-4 '>eTICKET</p>
            <div className=' mx-auto bg-[#fff9c4] px-8 py-8 rounded-lg border-2 border-[#ffb74d]'>
                <div className='flex justify-between'>
                    <div className="flex gap-2 items-center ">
                        <p className='font-bold text-xl'>{booking?.routeId.sourceCity}</p>
                        <AiOutlineArrowRight className='font-bold  text-xl' />
                        <p className='font-bold  text-xl'>{booking?.routeId.destinationCity}</p>
                        <p className='text-lg ml-3 mr-7'>{date}</p>
                    </div>
                    <div>
                        <p className='font-bold'><span >Ticket No:  </span>{booking?._id}</p>
                    </div>
                </div>
                <div className='border-2 border-[#ffb74d] mt-4  mb-6'></div>


                <div className='flex justify-between'>
                    <div className='flex flex-col gap-1 w-[20%]'>
                        <p className='font-bold'>{booking?.busId.name}</p>
                        <p className='text-gray-400'>{booking?.busId.busType}</p>
                    </div>
                    <div className='flex flex-col gap-1 w-[20%]'>
                        <p className='font-bold'>{booking?.boardingPoint[0].time}</p>
                        <p className='text-gray-400'>Boarding Time</p>
                    </div>
                    <div className='flex flex-col gap-1 w-[20%]'>
                        <p className='font-bold'>{booking?.boardingPoint[0].pointAddress}</p>
                        <p className='text-gray-400'>Boarding Address</p>
                    </div>
                </div>
                <div className='border border-[#ffb74d] mt-4  mb-4'></div>

                <div className='flex  justify-between'>
                    <div className='flex flex-col gap-1 w-[20%]'>
                        <p className='font-bold'>Dropping Point Details</p>
                    </div>
                    <div className='flex flex-col gap-1 w-[20%]'>
                        <p className='font-bold'>{booking?.droppingPoint[0].time}</p>
                        <p className='text-gray-400'>Dropping Time</p>

                    </div>
                    <div className='flex flex-col gap-1 w-[20%]'>
                        <p className='font-bold'>{booking?.droppingPoint[0].pointAddress}</p>
                        <p className='text-gray-400'>Dropping Point Address</p>

                    </div>
                </div>
                <div className='border border-[#ffb74d] mt-4 mb-1'></div>


                <p className='text-gray-400 mb-4 '>Passenger Details</p>
                {booking?.seats.map((x) => (
                    <div className='flex mt-2 justify-between' key={x._id}>


                        <div className='flex flex-col gap-1 w-[20%]'>
                            <p className='font-bold'>{x.passengername} <span className='ml-1 text-gray-400'>{x.passengerage} [{x.passengergender}]</span></p>


                        </div>
                        <div className='flex flex-col gap-1 w-[20%]'>
                            <p className='font-bold'>{x.seatNumber}</p>
                            <p className='text-gray-400'>Seat Number</p>

                        </div>
                        <div className='flex flex-col gap-1 w-[20%]'>
                            <p className='font-bold'>{x.seatType}</p>
                            <p className='text-gray-400'>Seat Type</p>

                        </div>

                    </div>
                ))}

                <div className='border border-[#ffb74d] mt-4  mb-4'></div>
                <div className='flex justify-between mt-5'>
                    <div className='w-[20%]'></div>
                    <div className=' w-[20%]'></div>
                    <p className=' w-[20%] text-sm'>Total Fare:  <span className='font-bold text-lg'>Rs {booking?.amount}</span></p>
                </div>



            </div>

        </div>
    )
}

export default OperatorTicketComponent;